import { NavigateFunction } from 'react-router'

import { PocketComponent } from '../components/PocketComponent'
import { RecordFactory } from '../models/RecordFactory'
import { User } from '../models/User'

export const splitName = (user: User) => {
    const nameParts = user.name?.split(' ') ?? []
    let firstNamePart, lastNamePart
    if (nameParts.length > 1) {
        lastNamePart = nameParts[nameParts.length - 1]
        firstNamePart = nameParts.splice(0, nameParts.length - 1).join(' ')
    }
    else {
        firstNamePart = user.name
    }

    return [firstNamePart, lastNamePart]
}

export function getEditionID(user: User) {
    return user.edition?.id || `${user.industry?.id}-industry-edition`
}

export const upgradeUserAccount = async (
    base: PocketComponent,
    user: User,
    navigate: NavigateFunction
) => {
    base.showProgressBar('Upgrading account..')
    await RecordFactory.getInstance().submitUpgrade(user)
    base.showProgressBar('Thank you! Your account is now upgraded.')
    await new Promise((resolve) => setTimeout(resolve, 2000))
    base.showProgressBar('Syncing account..')
    await RecordFactory.getInstance().sync(user.id!)
    base.hideProgressBar()
    navigate('/')
}
